import * as generation from './docGenerationService';
import { uploadSystemGeneratedDocument, isErrorResponse } from './docStorageService';
import { validateSubmissionDocuments, finalizeSubmissionDocuments } from './documentWorkflowService';

/** Used by initial and continuing-review forms, both drafts and revisions. */
export async function submitDocumentPackage(
  submissionId: string,
  data: Record<string, any>,
  sections: Parameters<typeof generation.generatePdfFromFormData>[1],
  onStep: (step: number) => void,
) {
  onStep(0);
  await validateSubmissionDocuments(submissionId, data);
  const fieldDefinitions = sections.flatMap(section => section.items.filter(field => field.name).map(field => ({
    name: field.name!, label: field.label, type: field.itemType, section: section.heading,
  })));
  const names = { submissionId, refName: data.ref_name || 'UntitledStudy', sponsorName: data.sponsor_name || 'UnknownSponsor', sponsorProtocolNumber: data.sponsor_protocol_number || 'NoProt' };
  onStep(1);
  const pdf = await uploadSystemGeneratedDocument({
    ...names, docType: 'submission_form_pdf', fileBlob: await generation.generatePdfFromFormData(data, sections, fieldDefinitions),
  });
  if (isErrorResponse(pdf)) throw new Error(`PDF upload failed: ${pdf.message}`);
  onStep(2);
  const markdown = await generation.generateMarkdownFromFormData(data, sections, fieldDefinitions);
  const md = await uploadSystemGeneratedDocument({
    ...names, docType: 'submission_form_markdown', fileBlob: new Blob([markdown], { type: 'text/markdown' }),
  });
  if (isErrorResponse(md)) throw new Error(`Markdown upload failed: ${md.message}`);
  onStep(3);
  await finalizeSubmissionDocuments(submissionId, data, [pdf.id, md.id]);
}
